import { useLocation } from "wouter";
import { Plus, ChevronDown, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useUiStore } from "@/lib/stores/uiStore";

// Botón primario de captura (vive en la cabecera de cada página — rediseño 2026-07-02).
export const CaptureButton = ({ label = "Capturar contenido" }) => {
  const openCapture = useUiStore((s) => s.openCapture);
  return (
    <Button onClick={openCapture} data-testid="capture-header-button" className="shrink-0">
      <Plus className="h-4 w-4" strokeWidth={2} />
      <span className="hidden sm:inline">{label}</span>
      <ChevronDown className="h-3.5 w-3.5 opacity-70" strokeWidth={2} />
    </Button>
  );
};

// Buscador de cabecera (lleva a /buscar, la búsqueda real vive allí).
export const HeaderSearch = ({ placeholder = "Buscar en tu biblioteca…" }) => {
  const [, navigate] = useLocation();
  return (
    <button
      type="button"
      onClick={() => navigate("/buscar")}
      data-testid="header-search-button"
      className="hidden lg:flex items-center gap-2 w-64 h-9 rounded-md border bg-card px-3 text-sm text-muted-foreground hover:border-teal-300/60 transition-colors"
    >
      <Search className="h-4 w-4" strokeWidth={1.75} />
      <span className="truncate">{placeholder}</span>
      <kbd className="ml-auto rounded border bg-secondary px-1.5 py-0.5 text-[11px]">⌘K</kbd>
    </button>
  );
};

export const PageHeader = ({ title, subtitle, actions, className }) => (
  <div className={className}>
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="font-serif text-3xl tracking-tight">{title}</h1>
        {subtitle && <p className="mt-1.5 text-muted-foreground text-[15px]">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0 pt-1">{actions}</div>}
    </div>
  </div>
);
